import { Directive, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Directive() // Use @Directive() for classes with @Inputs but no template/styles
export abstract class BaseChannelSelector {
  // Base Inputs - provide specific defaults in derived classes if needed
  @Input() initialButtonText: string;
  @Input() defaultInternalOnly = false;
  @Input() defaultExternalOnly = false;
  @Input() hideChannelTypeFilter = false;
  @Input() hideSecondaryTeams = true;
  @Input() hideUnlinkButton = false;
  @Input() hideLinkedToText = false;

  constructor(protected modalCtrl: ModalController) {}

  // Abstract methods to be implemented by derived components
  abstract openModal(): Promise<void>;
  abstract getDisplayText(): string;
  abstract clearSelection(): void;
}
